import facepaint from "facepaint";

// Breakpoints support with [mobil, desktop]
const breakpoints = [480, 1200];

export const mq = facepaint(
  breakpoints.map((bp) => `@media (min-width: ${bp}px)`)
);
